import type { TransportOrderShip, TransportOrderShipVo } from "@zhihaoscm/entity";

import type { TransportOrderShipQueryParam } from "../../../../common/types/transportOrderShip";
import type { Page } from "../../../../common/types/base/BaseEntity";
import { QUERY_TYPE } from "../../../../common/enum/transportOrderShip";
import { BaseService } from "./baseService";
import httpRequest from "./index";

// 船运单
export class TransportOrderShipService extends BaseService<
    TransportOrderShip,
    TransportOrderShipVo,
    TransportOrderShipQueryParam,
    any
> {
    // 修改实际结算吨位
    async updateFreightSettlementTonnage({
        id,
        freightSettlementTonnage
    }: {
        id: number;
        freightSettlementTonnage: number;
    }): Promise<any> {
        return this.service.put(`${this.path}/update/freight-settlement-tonnage/${id}`, { freightSettlementTonnage });
    }
    // 发航确认
    async confirmationDeparture({ id, drainage }: { id: number; drainage: number }): Promise<void> {
        await this.service.put(`${this.path}/confirmation-departure/${id}`, { drainage });
    }

    // 同意卸货
    // @confirmable("是否要帮货主同意卸货", "同意卸货", "已确认") 移除此处装饰器语法，二次确认弹窗需在调用处实现
    async agreeUnload(id: string): Promise<any> {
        await this.service.put(`${this.path}/agree-unload/${id}`);
    }

    async getInfo(id: number | string): Promise<TransportOrderShipVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    public async paging(params: TransportOrderShipQueryParam): Promise<Page<TransportOrderShipVo>> {
        params.queryType = QUERY_TYPE.SHIPOWNER.code;
        // params.state = 1;
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    /**
     * 下拉vo列表
     */
    public async voSelector(params: any): Promise<Array<TransportOrderShipVo>> {
        const { data } = await this.service.get(`${this.path}/selector-vo`, { params });
        return data;
    }

    async confirm(id: string, params: Record<string, any>) {
        return await this.service.put(`${this.path}/upload-payment/${id}`, params);
    }

    public async pay(id: string | number, ownerPayFileId: string): Promise<any[]> {
        const { data } = await this.service.put(`${this.path}/pay/${id}`, { ownerPayFileId });
        return data;
    }
    // 完成
    async putOrderShipComplete(id: string | number): Promise<any[]> {
        const { data } = await this.service.put(`${this.path}/complete/${id}`);
        return data;
    }
}

export const transportOrderShipService = new TransportOrderShipService("/transport/order/ship", httpRequest);
